import clsx from 'clsx';
import { ImgHTMLAttributes, ReactEventHandler, useCallback, useState } from 'react';

type FlagProps = {
    fallback?: string;
    flag?: string;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, 'onError' | 'src'>;

const BASE_FLAG_SRC = '/static/flags';

const Flag = ({ flag, alt = `Flag of ${flag}`, fallback = 'victron', ...props }: FlagProps) => {
    const [hasProducedError, setHasProducedError] = useState(false);
    const handleError: ReactEventHandler<HTMLImageElement> = useCallback(
        ({ currentTarget }) => {
            currentTarget.src = `${BASE_FLAG_SRC}/${fallback}.svg`;
            currentTarget.alt = 'Flag of Victron';
            setHasProducedError(true);
        },
        [setHasProducedError]
    );

    return (
        <img
            src={`${BASE_FLAG_SRC}/${flag?.toLowerCase()}.svg`}
            alt={alt}
            {...props}
            className={clsx('w-[27px] h-[15px]', props.className)}
            onError={!hasProducedError ? handleError : undefined}
        />
    );
};

export { Flag };
